/** @jsxImportSource @emotion/react */
import type { Interpolation } from "@emotion/react";
import { Link } from "@packages/framework";
import type { TextFirstSectionItem as TextFirstSectionItemSchema } from "@packages/sdk";
import { getURLFromDeeplink } from "@packages/sdk";

import type { ThemeType } from "../../../../../global/emotion";
import { radius, spacing } from "../../../../../global/emotion";
import { Text } from "../../_core/Text/Text.emotion";
import { ContentSmall } from "../content/ContentSmall/ContentSmall.emotion";

const sectionStyle: Interpolation<ThemeType> = (theme) => ({
  background: theme.semanticColors.neutralsLowest,
  borderRadius: radius.m,
  display: "flex",
  flexDirection: "column",
  gap: spacing.m,
  height: spacing.full,
  padding: spacing.m,
});

export const TextFirstSectionItem = ({
  title,
  description,
  snippet,
  image_url,
  deeplink,
}: TextFirstSectionItemSchema["reference"]) => {
  return (
    <Link href={getURLFromDeeplink({ deeplink })} css={sectionStyle}>
      <ContentSmall
        imgSrc={{ fallback: image_url }}
        title={title}
        description={description}
      />
      <Text as="div" lineClamp={2}>
        {snippet}
      </Text>
    </Link>
  );
};
